import { useTranslation } from 'react-i18next'

import { CardContent, Flex } from '@percent/lemonade'
import type { InternalService } from '@percent/admin-dashboard/api/actions/internalServices/internalServices.types'
import { getDate } from '@percent/admin-dashboard/common/utility/getDate'

const notSetStyle = { color: 'var(--content-disabled, #b6b4b9)' }

type ServiceOverviewProps = { service: InternalService }

export function ServiceOverview({ service }: Readonly<ServiceOverviewProps>) {
  const { t } = useTranslation()

  return (
    <Flex direction="column" p="lg">
      <CardContent title={t('typography.ownerTeam')} testId="service-detail-owner-team">
        {service.ownerTeam}
      </CardContent>
      <CardContent title={t('typography.description')} testId="service-detail-description">
        {service.description || <span style={notSetStyle}>{t('serviceDetail.overview.noDescription')}</span>}
      </CardContent>
      <CardContent title={t('table.createdBy')} testId="service-detail-created-by">
        {service.createdBy}
      </CardContent>
      <CardContent title={t('typography.createdAt')} testId="service-detail-created-at">
        {getDate(service.createdAt)}
      </CardContent>
      <CardContent title={t('typography.updatedAt')} testId="service-detail-updated-at">
        {getDate(service.updatedAt)}
      </CardContent>
    </Flex>
  )
}
